module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><input type="checkbox" class="transaction-select" value='+
((__t=( id ))==null?'':_.escape(__t))+
'></td>\n<td>'+
((__t=( transaction_date ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( costcentre ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( bank_account ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( contact ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( matched_contact ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( description ))==null?'':_.escape(__t))+
'</td>\n<td class="amount">'+
((__t=( amount ))==null?'':_.escape(__t))+
'</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/transaction/row.html
// module id = 247
// module chunks = 0